export function verif(rows, month, AN) {


    var mois = (month < 10 ? '0' : '') + month.toString();
    var annee = AN.toString()

    // console.log(mois , annee)

    var tabSkandar = [];
    var colFrs = 0;
    var colNom = 0;
    var colRefP = 0;
    var colLib = 0;
    var colTypeC = 0;
    var colNomC = 0;
    var colLibDep = 0;
    var colGouv = 0;
    var colAn = 0;
    var colMois = 0;
    var colQte = 0;
    var head = false;
    var test = false

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {

        const row = rows[rowIndex];
        const lowercaseRow = row.map(val => val.toString().toLowerCase());

        if (!head
            && lowercaseRow.includes("frs")
            && lowercaseRow.includes("nom")
            && lowercaseRow.includes("refprod")
            && lowercaseRow.includes("libelle")
            && lowercaseRow.includes("typeclient")
            && lowercaseRow.includes("nom_client")
            && lowercaseRow.includes("lib_depot")
            && lowercaseRow.includes("gouvernorat")
            && lowercaseRow.includes("annee")
            && lowercaseRow.includes("mois")
            && lowercaseRow.includes("qte")
        ) {
            colFrs = lowercaseRow.indexOf("frs")
            colNom = lowercaseRow.indexOf("nom");
            colRefP = lowercaseRow.indexOf("refprod")
            colLib = lowercaseRow.indexOf("libelle");
            colTypeC = lowercaseRow.indexOf("typeclient")
            colNomC = lowercaseRow.indexOf("nom_client");
            colLibDep = lowercaseRow.indexOf("lib_depot")
            colGouv = lowercaseRow.indexOf("gouvernorat");
            colAn = lowercaseRow.indexOf("annee")
            colMois = lowercaseRow.indexOf("mois");
            colQte = lowercaseRow.indexOf("qte");
            head = true;
            continue;
        }

        // console.log(row[colMois], row[colMois] === mois, row[colAn],annee, row[colAn] === annee)

        if ((row[colMois] === mois) && (row[colAn] == annee)) {
            // console.log(row.length)
            test = true

            var typeclient = row[colTypeC].toLowerCase().split(' ')[0];

            // console.log(typeclient)

            if (typeclient === "gr") {
                tabSkandar.push({
                    frs: row[colFrs],
                    nom: row[colNom],
                    refP: row[colRefP],
                    lib: row[colLib],
                    typeC: row[colTypeC],
                    nomC: row[colNomC],
                    libD: row[colLibDep],
                    gouv: row[colGouv],
                    ans: row[colAn],
                    mois: row[colMois],
                    qte: row[colQte],
                });
            }
        }


    }


    // console.log(tabSkandar)

    return { test: test, tabSkandar: tabSkandar };
}
